import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CustomToastService } from '@foxera/shared/services/custom-toast.service';
import { catchError, throwError } from 'rxjs';

// Caller already shows the failure. Skip the bottom error bar.
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const ErrorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  const customToastService = inject(CustomToastService);

  return next(req).pipe(
    catchError(() => {
      const message = "Something went wrong. Please try again. Vixey has been notified.";
      if (!req.context.get(SKIP_ERROR_TOAST)) {
        customToastService.showError(message);
      }
      return throwError(() => new Error(message));
    })
  );
};